import i18next from "i18next"
import { call, delay, fork, put, select, takeEvery } from "redux-saga/effects"
import * as fetchApi from "services/api/fetchApi"
import { getGlobalUi, globalUiAction } from "services/globalUi"
import { orderScooterAction } from "services/orderScooter" // eslint-disable-line no-unused-vars
import { scooterAction } from "services/scooter" // eslint-disable-line no-unused-vars
import { webStorage } from "services/utils"
import Cookies from "universal-cookie"
import * as globalData from "views/constants/jsonData/globalData"

import { userStateAction } from "./action"
import { getUserState } from "./selector"

const cookies = new Cookies()

function* saveTemporaryStorage({ payload }) {
  const userState = yield select(getUserState)
  const currentName = payload.name
    .split("")
    .map((str, index) => (index === 0 ? str.toUpperCase() : str))
    .join("")

  if (payload.num) {
    let allData = []
    let emptyNo = null

    for (let index = 0; index < payload.num; index++) {
      const currentData = webStorage.getLs(`sales${currentName}Temporary${index}`)

      if (currentData) {
        allData.push({ index: index, email: currentData.UserData.Email, date: currentData.createTime })
      } else {
        allData.push({ index: index, email: null, date: `${new Date("1983-07-31")}` })
      }
    }

    const sameBuyer = allData.find((obj) => obj.email === payload.data.UserData.Email)

    if (sameBuyer) {
      emptyNo = sameBuyer.index
    } else {
      const lastData = [...allData].sort((a, b) => new Date(b.date) - new Date(a.date)).pop()
      yield webStorage.removeLs(`sales${currentName}Temporary${lastData.index}`)
      emptyNo = lastData.index
    }

    yield webStorage.setLs(`sales${currentName}Temporary${emptyNo}`, { ...payload.data, createTime: `${new Date()}` })
  } else {
    yield cookies.set(`sales${currentName}Timing`, userState.userData.UserId, { maxAge: 18000 })
    yield webStorage.setLs(`sales${currentName}Data`, payload.data)
  }
}

function* fetchOCRRequest({ payload }) {
  const globalUi = yield select(getGlobalUi)
  yield put(globalUiAction.setGlobalUI({ isLoading: true }))
  // IdrType 身分證正面:1, 身分證反面:2, 香港居民身份證:3, 澳門居民身份證 第二代:4, 澳門居民身份證 第一代:5, 大陸身份證正面:6, 大陸身份證背面:7, 中華民國駕照 (新版):31, 台灣健保卡:41, 台灣護照: 51, 台胞証: 52, 國際機讀護照: 53, 中華民國汽車行車執照: 71, 中華民國居留證 正面: 92, 中華民國居留證 背面: 93, Barcode_Set1 (support: QR code & Code 39): 101, CreditCard 信用卡: 111
  let postData = {
    WaterMarkPosition: 2,
    WaterMarkColorR: 32,
    WaterMarkColorG: 178,
    WaterMarkColorB: 170,
    WaterMarkText: "gogoro 業務用",
    FileType: "jpg",
    IdrType: payload.type,
    ResultFileType: 1,
    OutputImageType: 7,
    ExpressMode: 0,
    UploadFile: payload.image64, // base64
  }

  try {
    // const response = yield call(fetchApi.postDataByFetch, `${globalData.OCRHost}/NsIDR/UploadImage`, postData);
    const response = yield call(fetchApi.postDataByFetch, `/${globalUi.langCode}/api/ocr/upload-image`, postData)

    if (response.data.ErrorCode === 0) {
      const startTime = new Date()
      yield call(fetchOCRStatus, response.data.OcrSN, payload.name, startTime)
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.StatusCode,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: "Send OCR Image Error",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    if (payload.resolve) yield call(payload.resolve)
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* fetchOCRStatus(OcrSN, name, startTime) {
  const globalUi = yield select(getGlobalUi)
  const postData = {
    OcrSN: OcrSN,
    sysID: globalData.OCRSysID,
    mac: "",
  }

  try {
    const now = new Date()
    yield delay(now - startTime < 1000 ? 1000 : 500)
    const statusResponse = yield call(fetchApi.postDataByFetch, `/${globalUi.langCode}/api/ocr/get-status`, postData)

    if (statusResponse.data.StatusCode === 0) {
      const response = yield call(fetchApi.postDataByFetch, `/${globalUi.langCode}/api/ocr/get-recog-info`, postData)
      yield put({ type: userStateAction.SET_USER_STATE, payload: { [`${name}`]: response.data } })
    } else if (statusResponse.data.StatusCode === 2 && now - startTime < 10000) {
      yield call(fetchOCRStatus, OcrSN, name, startTime)
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: statusResponse.data.StatusCode,
        message: i18next.t("sales:tr.text_ocr_recognize_fail"),
      }
    }
  } catch (error) {
    yield put({ type: userStateAction.SET_USER_STATE, payload: { [`${name}`]: undefined } }) // initial driverLicense field when ocr fail
    // yield put(globalUiAction.openErrorModal({
    //   title: i18next.t('sales:tr.title_fetch_ocr_data_error'),
    //   content: `${error.name}, ${error.message}`,
    // }));
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchSaveTemporaryStorage() {
  yield takeEvery(userStateAction.SAVA_TEMPORARY_STORAGE, saveTemporaryStorage)
}

export function* watchFetchOCRRequest() {
  yield takeEvery(userStateAction.FETCH_OCR_REQUEST, fetchOCRRequest)
}

//=====================================
//  ROOT
//-------------------------------------

export const userStateSaga = [fork(watchSaveTemporaryStorage), fork(watchFetchOCRRequest)]
